/*@ngInject*/
const UIScrollIntoViewDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let element = $($elm),
            viewport = $('.formViewer').first();

        function handleClick(event) {
            let targetElement = $(event.target),
                containerOffsetTop,
                elementOffsetTop,
                currentScroll,
                topMargin,
                isUiSelect,
                uiSelectParents,
                bottomOfElementYpos = element.offset().top + element.height(),
                bottomOfViewportYpos = viewport.offset().top + viewport.height(),
                numberOfPixelsOffscreen = bottomOfElementYpos - bottomOfViewportYpos,
                newScrollPosition;

            if (numberOfPixelsOffscreen > 20 && element.height() < viewport.height()) {
                containerOffsetTop = viewport.offset().top;
                elementOffsetTop = element.offset().top;
                currentScroll = viewport.scrollTop();
                topMargin = 75;
                newScrollPosition = (currentScroll + elementOffsetTop) - containerOffsetTop - topMargin;

                if (currentScroll !== newScrollPosition) {
                    viewport.animate({
                        scrollTop: newScrollPosition
                    }, 300);

                    isUiSelect = targetElement.hasClass('ui-select-match');
                    uiSelectParents = targetElement.parents('.ui-select-match');

                    if (isUiSelect || (uiSelectParents && uiSelectParents.length > 0)) {
                        event.stopPropagation();
                        event.preventDefault();
                        $timeout(function () {
                            targetElement.click();
                        }, 500);
                        return false;
                    }
                }
            }
        }

        if($attrs['uiScrollIntoView'] !== 'false') {
            // use add event listener so we can use the capture phase of the event
            element[0].addEventListener('click', handleClick, true);

            $scope.$on('$destroy', function () {
                element[0].removeEventListener('click', handleClick, true);
            });
        }
    };

    return {
        scope: true,
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiScrollIntoView', UIScrollIntoViewDirective);
